import axios from "./axios-auth";

const emailPassword = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/emailpassword",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from emailPassword");
      });
  });

const getUserClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getuserclients",
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while getting user clients");
      });
  });

const getUsers = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getusers",
      data: payload,
      method: "POST",
    })
      .then((resp) => {
        console.log("data logged");
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while getting users");
      });
  });

const InsertUser = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/insertuser",
      data: params,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

const getDetails = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getuserdetailsbyid",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while getting user details");
      });
  });

const UpdateDetails = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateuserbyid",
      data: payload,
      method: "PUT",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while updating user details");
      });
  });

const ChangePoints = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updatepointsbyuserid",
      data: payload,
      method: "PUT",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while updating user points");
      });
  });

const CreditedPoints = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updatecreditpointsbyid",
      data: payload,
      method: "PUT",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while crediting user points");
      });
  });

const ReportsPageResult = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/gettransactionreportbyuserid",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while getting user report");
      });
  });

const TransactionDropDown = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/gettransactions",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while getting transaction drop down");
      });
  });

const LockStatusUpdate = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateuserlock",
      data: payload,
      method: "PUT",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while updating lock status");
      });
  });

export {
  getUserClients,
  getUsers,
  InsertUser,
  getDetails,
  UpdateDetails,
  ChangePoints,
  CreditedPoints,
  ReportsPageResult,
  TransactionDropDown,
  LockStatusUpdate,
  emailPassword,
};
